// extracted by mini-css-extract-plugin
export default {"page":"eZ-z","cartModal":"fZ-z","checkout":"gZ-z","placeholder":"hZ-z","account":"iZ-z"};